export enum TypeFilter {
  DATE,
  TEXT,
  CURRENCY,
  TAXONOMY,
  COLLECTION_OF_TAXONOMY,
  NEWIN,
  SPECIAL_EDITION,
  CLASSIFICATIONS,
  BOOLEAN,
  STOCK,
  STORE_STOCK,
  NONE
}
